import type { AxiosResponse } from 'axios';

import { useApiResponse } from '@/composables/useApiResponse';
import { QUERY_LOCATIONS } from '@/constants';
import type { LocationModel } from '@/generated';
import useAuthStore from '@/stores/useAuthStore';
import { useQuery } from '@tanstack/vue-query';
import { storeToRefs } from 'pinia';
import { computed } from 'vue';

import { locationApi } from './generatedApi';

export const useLocations = () => {
    const { isAuthenticated } = storeToRefs(useAuthStore());
    const apiResponseCode = useApiResponse();

    return useQuery({
        queryKey: [QUERY_LOCATIONS],
        queryFn: async (): Promise<LocationModel[]> => {
            try {
                const response: AxiosResponse<LocationModel[]> =
                    await locationApi.apiV1LocationGet();

                if (apiResponseCode(response.status).ok) {
                    return response.data;
                } else {
                    throw new Error(`Could not load locations. ${response.statusText}`);
                }
            } catch (e) {
                console.error(e);
                throw e;
            }
        },
        enabled: computed(() => isAuthenticated.value),
    });
};
